export default __webpack_public_path__ + "static/media/DECDOM2024.1b4ef0b5.png";